import { Link } from "@mui/material";

import "../authenticator-components.css";

const ImprintFooter = () => {
  return (
    <div className="footer">
      <Link
        className="imprint-link"
        href="https://ax4.com/ax4/html/201910_SIEMENS_Terms-of-Use_EN"
        target="_blank"
      >
        By using our application, you consent to the Terms of Use as set out
        under this link.
      </Link>
      <Link
        className="imprint-link"
        href="https://www.siemens.com/en-us/privacy-notice/"
        target="_blank"
      >
        Data Privacy Notice
      </Link>
      <Link
        className="imprint-link"
        href="https://plm.sw.siemens.com/en-US/digital-logistics/imprint"
        target="_blank"
      >
        Imprint
      </Link>
    </div>
  );
};

export default ImprintFooter;
